var v4519 = {}.toString;
module.exports = Array.isArray || function (p5098) {
  return v4519.call(p5098) == "[object Array]";
};